import { getReq, norReq } from '../config/http'

export const checkType = () => getReq('/lc/questionnaire/check?type=100000')

export const questionnaireCommit = p => norReq('/lc/questionnaire/commit', p)
